import { PurchaseOrderInfo } from '../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { ChannelManager } from 'common/manager';
import { NOT_AVAILABLE, ANALYTICS_SHARED_CONSTANTS } from 'common/constants/SharedConstants';
import { getUserType, getValueOrDefaultObject, getCouponDetails } from 'common/utilities/utils';
export const updatePurchaseAnalytics = (
  OrderReducerData,
  currencyConversionFactor,
  userStatus,
  OrderData,
  cashTransactionID,
) => {
  const { additionalChargeLines, foodLines, paymentReferences, total, inclusiveTaxTotal } = OrderReducerData;
  const { couponCode = '', discountTotal = '' } = getCouponDetails(OrderReducerData);
  const { localized = false, loggedIn = false } = getValueOrDefaultObject(userStatus);
  const userType = getUserType(localized, loggedIn);
  const orderItemsList = [];
  let transactionId;
  foodLines?.forEach((foodLineItem, idx) => {
    const itemVariant = [];
    foodLineItem?.item?.modGrps?.forEach(group => {
      itemVariant.push(group?.modifiers?.[0]?.name);
    });
    const { categoryId = '', categoryName = '' } = foodLineItem?.item;
    orderItemsList?.push({
      currency: ANALYTICS_SHARED_CONSTANTS.INR,
      discount: discountTotal / currencyConversionFactor,
      item_name: foodLineItem?.item?.dname?.[0]?.value || NOT_AVAILABLE,
      item_id: foodLineItem?.item?.id || NOT_AVAILABLE,
      price: foodLineItem?.item?.unitPrice / currencyConversionFactor || NOT_AVAILABLE,
      item_variant: itemVariant.join(', ') || NOT_AVAILABLE,
      quantity: foodLineItem?.quantity || NOT_AVAILABLE,
      item_category: categoryName,
      item_list_name: categoryName,
      item_list_id: categoryId,
      index: idx,
    });
  });

  if (cashTransactionID) {
    transactionId = cashTransactionID;
  } else {
    transactionId =
      ChannelManager?.shouldGoogleSpotIgnoreOloFailure && ChannelManager?.transactionId
        ? ChannelManager?.transactionId
        : paymentReferences?.[0]?.transactionId ?? NOT_AVAILABLE;
  }

  PurchaseOrderInfo(userType, {
    affiliation: ANALYTICS_SHARED_CONSTANTS.ONLINE_STORE,
    transaction_id: transactionId,
    value: total ? total / currencyConversionFactor : NOT_AVAILABLE,
    tax: inclusiveTaxTotal ? inclusiveTaxTotal / currencyConversionFactor : NOT_AVAILABLE,
    shipping:
      additionalChargeLines?.[0]?.chargeType === 'delivery-charge'
        ? additionalChargeLines?.[0]?.amount / currencyConversionFactor
        : NOT_AVAILABLE,
    currency: ANALYTICS_SHARED_CONSTANTS.INR,
    coupon: couponCode,
    items: orderItemsList || NOT_AVAILABLE,
  });
};
